(() => {
  const dialog = document.querySelector('#vp-artwork-dialog');
  if (!dialog) return;
  const image = dialog.querySelector('img');
  let opener;
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-vp-artwork]');
    if (button) {
      opener = button;
      image.src = button.dataset.vpArtwork;
      image.alt = button.dataset.vpAlt || '';
      image.removeAttribute('height');
      dialog.showModal();
    }
    if (event.target.closest('[data-vp-close]')) dialog.close();
  });
  dialog.addEventListener('click', event => {
    if (event.target === dialog) {
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    }
  });
  dialog.addEventListener('close', () => opener?.focus());
})();
